import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '💪',
    title: 'pages.quizOnboarding.whatWouldChange.answer1',
    value: 'confidence',
  },
  {
    emoji: '💼',
    title: 'pages.quizOnboarding.whatWouldChange.answer2',
    value: 'career',
  },
  {
    emoji: '✈️',
    title: 'pages.quizOnboarding.whatWouldChange.answer3',
    value: 'travel',
  },
  {
    emoji: '🤝',
    title: 'pages.quizOnboarding.whatWouldChange.answer4',
    value: 'connection',
  },
]

export default function WhatWouldChangePage() {
  const language = useSelectedLanguageName()

  return (
    <QuizChoicePage
      answers={answers}
      title="pages.quizOnboarding.whatWouldChange.title"
      translationInterpolation={{ language }}
    />
  )
}
